import Npv from './Npv';

const LoansRepaymentChart = () => <Npv report="MonthlyNPV" desc="Monthly NPV Summary" />;

export default LoansRepaymentChart;
